<template>
  <div class="download_view">
    <el-button
      type="success"
      plain
      icon="el-icon-download"
      size="mini"
      @click="handleDownload('B')"
      >B端图册</el-button
    >
    <el-button
      type="success"
      plain
      icon="el-icon-download"
      size="mini"
      @click="handleDownload('C')"
      >C端图册</el-button
    >
    <el-button
      type="success"
      plain
      icon="el-icon-download"
      size="mini"
      @click="handleDownload('X')"
      >详情图册</el-button
    >
  </div>
</template>

<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  props: ["businessPics", "customerPics", "proContent"],
  methods: {
    handleDownload(type) {
      let arrImages = [];
      if (type == "B") {
        this.businessPics.forEach((v, i) => {
          arrImages[i] = {
            fileUrl: v.SpuPicUrl,
            renameFileName: `${i + 1}.${v.SpuPicUrl.substring(
              v.SpuPicUrl.lastIndexOf(".") + 1
            )}`,
          };
        });
      } else if (type == "C") {
        this.customerPics.forEach((v, i) => {
          arrImages[i] = {
            fileUrl: v.SpuPicUrl,
            renameFileName: `${i + 1}.${v.SpuPicUrl.substring(
              v.SpuPicUrl.lastIndexOf(".") + 1
            )}`,
          };
        });
      } else if (type == "X") {
        var reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
        var arr = [];
        let tem = null,
          i = 0;
        while ((tem = reg.exec(this.proContent))) {
          arrImages.push({
            fileUrl: tem[2],
            renameFileName: `${i + 1}.${tem[2].substring(
              tem[2].lastIndexOf(".") + 1
            )}`,
          });
          i++;
        }
      }
      this.filesToRar(
        arrImages,
        type == "B" ? "B端图册" : type == "C" ? "C端图册" : "详情图册"
      );
    },
    /**文件打包
     * arrImages:文件list:[{fileUrl:文件url,renameFileName:文件名}]
     * filename 压缩包名
     * */
    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      _this.title = "正在加载压缩文件";

      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
          cache[item.renameFileName] = data;
        });
        promises.push(promise);
      }

      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            _this.title = "正在压缩";
            // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
            _this.title = "压缩完成";
          });
        })
        .catch((res) => {
          _this.$message.error("文件压缩失败");
        });
    },
    //获取文件blob
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
  },
};
</script>

<style scoped>
.download_view {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
</style>